{
  "version": 1,
  "asset_id": "4ba5c52e-226d-4442-8dcf-e23c25c45e33",
  "project_id": "580971ff-48ef-43ae-ac1b-b79884f254e1",
  "url": "/__l5e/assets-v1/4ba5c52e-226d-4442-8dcf-e23c25c45e33/hero-video.mp4",
  "r2_key": "a/v1/580971ff-48ef-43ae-ac1b-b79884f254e1/4ba5c52e-226d-4442-8dcf-e23c25c45e33/hero-video.mp4",
  "original_filename": "hero-video.mp4",
  "size": 2652436,
  "content_type": "video/mp4",
  "created_at": "2026-10-16T05:21:12Z"
}
